<!-- Showcase for news -->
<ng-container *ngIf="type === TeaserShowcaseType.NEWS">
  <div class="top-news">
    <div class="teaser-row">
      <div class="teaser-col-lg-7">
        <hdi-teaser
          *ngIf="news.length > 0 && news[0]"
          [type]="TeaserType.LARGE"
          [imageSrc]="news[0].imageSrc"
          [imageAlt]="news[0].imageAlt"
          [imageTitle]="news[0].imageTitle"
          [background]="Colors.NEUTRAL_LIGHTER"
          [badges]="news[0].badges"
          [badgeSize]="Sizes.MEDIUM"
          [date]="news[0].date"
          [headline]="news[0].title"
          [headlineSize]="Headlines.H1"
          [description]="news[0].description"
          [href]="news[0].link?.href ?? ''"
          [hrefType]="news[0].link?.hrefType ?? HrefType.ANGULAR_ROUTE"
          [title]="news[0].link?.title ?? ''"
          [label]="news[0].link?.label ?? ''"
          [linkType]="news[0].link?.linkType ?? LinkType.PRIMARY_ARROW"
        ></hdi-teaser>
      </div>
      <div class="teaser-col-lg-5">
        <div class="teaser-row">
          <div class="teaser-col-12">
            <hdi-teaser
              *ngIf="news.length > 1 && news[1]"
              [type]="TeaserType.SMALL"
              [imageSrc]="news[1].imageSrc"
              [imageAlt]="news[1].imageAlt"
              [imageTitle]="news[1].imageTitle"
              [background]="Colors.NEUTRAL_LIGHTER"
              [badges]="news[1].badges"
              [badgeSize]="Sizes.MEDIUM"
              [date]="news[1].date"
              [headline]="news[1].title"
              [headlineSize]="Headlines.H5"
              [href]="news[1].link?.href ?? ''"
              [hrefType]="news[1].link?.hrefType ?? HrefType.ANGULAR_ROUTE"
              [title]="news[1].link?.title ?? ''"
              [label]="news[1].link?.label ?? ''"
              [linkType]="news[1].link?.linkType ?? LinkType.PRIMARY_ARROW"
            ></hdi-teaser>
          </div>
          <div class="teaser-col-12">
            <hdi-teaser
              *ngIf="news.length > 2 && news[2]"
              [type]="TeaserType.SMALL"
              [imageSrc]="news[2].imageSrc"
              [imageAlt]="news[2].imageAlt"
              [imageTitle]="news[2].imageTitle"
              [background]="Colors.NEUTRAL_LIGHTER"
              [badges]="news[2].badges"
              [badgeSize]="Sizes.MEDIUM"
              [date]="news[2].date"
              [headline]="news[2].title"
              [headlineSize]="Headlines.H5"
              [href]="news[2].link?.href ?? ''"
              [hrefType]="news[2].link?.hrefType ?? HrefType.ANGULAR_ROUTE"
              [title]="news[2].link?.title ?? ''"
              [label]="news[2].link?.label ?? ''"
              [linkType]="news[2].link?.linkType ?? LinkType.PRIMARY_ARROW"
            ></hdi-teaser>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="old-news">
    <hdi-teaser-container
      *ngIf="showOldNewsContainer"
      [showMoreLess]="news.length > 6"
      [initialVisibleTeasers]="3"
      [columns]="0"
      #teasersOverview
    >
      <hdi-teaser
        *ngFor="let news of news | slice: 3"
        #teaser
        [type]="TeaserType.SMALL"
        [id]="news.identifier"
        [imageSrc]="news.imageSrc"
        [imageAlt]="news.imageAlt"
        [imageTitle]="news.imageTitle"
        [badges]="news.badges"
        [badgeSize]="Sizes.MEDIUM"
        [date]="news.date"
        [headline]="news.title"
        [headlineSize]="Headlines.H5"
        [description]="news.description"
        [imageBorder]="true"
        [href]="news.link?.href ?? ''"
        [hrefType]="news.link?.hrefType ?? HrefType.ANGULAR_ROUTE"
        [title]="news.link?.title ?? ''"
        [label]="news.link?.label ?? ''"
        [linkType]="news.link?.linkType ?? LinkType.PRIMARY_ARROW"
      ></hdi-teaser>
    </hdi-teaser-container>
  </div>
</ng-container>

<!-- Showcase for topics -->
<ng-container *ngIf="type === TeaserShowcaseType.TOPICS">
  <div class="topic-row">
    <div class="topic-col-xl-7">
      <div class="topic-sub-row">
        <div
          class="topic-sub-col-6-md"
          *ngFor="let teaser of teasers | slice: 0 : 2"
        >
          <hdi-teaser
            [imageBorder]="teaser.imageBorder"
            [type]="teaser.type!"
            [headline]="teaser.headline!"
            [description]="teaser.description!"
            [date]="teaser.date"
            [imageSrc]="teaser.imageSrc"
            [target]="teaser.target"
            [label]="teaser.label ?? '' | capitalize"
            [background]="teaser.background!"
          >
          </hdi-teaser>
        </div>
      </div>
    </div>
    <div class="topic-col-xl-5">
      <div class="topic-sub-row">
        <div class="topic-sub-col-12">
          <hdi-teaser
            [type]="teasers[2].type!"
            [iconColor]="teasers[2].iconColor!"
            [headline]="teasers[2].headline!"
            [headlineSize]="teasers[2].headlineSize!"
            [iconType]="teasers[2].iconType!"
            [imageSrc]="teasers[2].imageSrc!"
            [target]="teasers[2].target!"
            [label]="teasers[2].label! | capitalize"
            [iconSize]="teasers[2].iconSize!"
            [background]="teasers[2].background!"
            [imageBorder]="teasers[2].imageBorder"
          >
          </hdi-teaser>
        </div>
        <div
          class="topic-sub-col-6-md"
          *ngFor="let teaser of teasers | slice: 3 : 5"
        >
          <hdi-teaser
            [date]="teaser.date"
            [type]="teaser.type!"
            [headline]="teaser.headline!"
            [imageSrc]="teaser.imageSrc!"
            [target]="teaser.target!"
            [label]="teaser.label! | capitalize"
          ></hdi-teaser>
        </div>
      </div>
    </div>
  </div>
</ng-container>
